import initialState from './initialState';
import * as types from '../actions/consentActions/actionTypes';

export default function consentReducer(state = initialState.consent, action) {
  switch (action.type) {
    case types.SET_CONSENTS:
      return {
        ...state,
        consents: action.consents
      };

    case 'CANCEL_OPERATION':
      return initialState.consent;

    default:
      return state;
  }
} 